import React from 'react';
import { useLocation } from 'react-router-dom';
import { APP_VERSION } from '../utils/version';

interface VersionIndicatorProps {
    onTap?: () => void;
}

const VersionIndicator: React.FC<VersionIndicatorProps> = ({ onTap }) => {
    const location = useLocation();
    
    // Only show in development mode
    if (process.env.NODE_ENV !== 'development') {
        console.log('VersionIndicator: Not in development mode, hiding');
        return null;
    }

    // Hide on Venere platform routes (Venere has its own version indicator)
    if (location.pathname.startsWith('/venere')) {
        return null;
    }

    return (
        <div 
            className="fixed bottom-4 right-4 bg-red-500 text-white text-lg px-4 py-2 rounded opacity-90 hover:opacity-100 transition-opacity z-40 cursor-pointer"
            onClick={onTap}
            title="Triple tap to show version info - Press Shift+V for hotkey"
            style={{ border: '3px solid red', fontWeight: 'bold' }} // More visible debug styling
        >
            v{APP_VERSION} - DEV MODE
        </div>
    );
};

export default VersionIndicator; 